import { render, staticRenderFns } from "./NotesWidget.vue?vue&type=template&id=7cf21a07&scoped=true&"
import script from "./NotesWidget.vue?vue&type=script&lang=js&"
export * from "./NotesWidget.vue?vue&type=script&lang=js&"
import style0 from "./NotesWidget.vue?vue&type=style&index=0&id=7cf21a07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf21a07",
  null
  
)

export default component.exports